import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  hiddenBreadCrumb: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  navigation: {
    marginBottom: theme.spacing(2),
    "& li:nth-last-child(2)": {
      display: "none",
    },
    "& .MuiBreadcrumbs-li:last-of-type": {
      marginLeft: "auto",
    },
  },
  border: {
    height: "1px",
    backgroundColor: "#e4eaec",
    border: "none",
  },
  borderNewUser: {
    border: "none",
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  linkDisabled: {
    color: theme.palette.action.disabled,
    cursor: "default",
  },
  currentPage: {
    color: "#a6a6a6",
  },
  title: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "24px",
    width: "53px",
    height: "26px",
    color: "#000000",
    whiteSpace: "nowrap",
  },
}));
